<div class="settings-page">
	<div class="settings-page__content">
		<div class="settings-card">
			<div class="settings-card__header">
				<img src="/assets/images/Group 24.svg" alt="" />
				<div class="settings-card__header-headline">
					<h2>Bine ați venit!</h2>
					<h4>Setările Dumneavoastră inUrbanism Sector 4</h4>
				</div>
			</div>
		</div>
	</div>

	<div class="content-box">
		<div class="settings-page-container">
			<mat-button-toggle-group [value]="selectedComponent" (change)="onChange($event)" class="settings-page_menu">
				<mat-button-toggle [value]="option" class="settings-page_menu-item"
					*ngFor="let option of componentKeys">
					<div style="text-align: left;">
						{{ option }}
					  </div>
				</mat-button-toggle>
			</mat-button-toggle-group>
		</div>
		<div class="settings-page__content">
			<!--
        <ng-container *ngIf="selectedComponent === SettingsOption.SECTIONS">
        <app-sections></app-sections>
      </ng-container>
      <ng-container *ngIf="selectedComponent === SettingsOption.PERMISIUNI">
        <app-permisiuni></app-permisiuni>
      </ng-container>
      <ng-container
        *ngIf="selectedComponent === SettingsOption.PERMISIUNI_ACTIUNI"
      >
        <app-permisiuni-actiuni></app-permisiuni-actiuni>
      </ng-container>
      <ng-container *ngIf="selectedComponent === SettingsOption.FUNCTII">
        <app-functii></app-functii>
      </ng-container>
    -->
			<ng-container *ngIf="selectedComponent === SettingsOption.JUDET">
				<app-judet></app-judet>
			</ng-container>
			<ng-container *ngIf="selectedComponent === SettingsOption.CERERE_PRIORITY">
				<app-cerere-priority></app-cerere-priority>
			</ng-container>
			<ng-container *ngIf="selectedComponent === SettingsOption.STATUS">
				<app-status></app-status>
			</ng-container>
			<ng-container *ngIf="selectedComponent === SettingsOption.CERERE_SABLOANE">
				<app-cerere-sabloane></app-cerere-sabloane>
			</ng-container>
			<ng-container *ngIf="selectedComponent === SettingsOption.REQUEST_TYPES">
				<app-request-types></app-request-types>
			</ng-container>

			<ng-container *ngIf="selectedComponent === SettingsOption.DOCUMENT_CATEGORY">
				<app-document-category></app-document-category>
			</ng-container>

			<ng-container *ngIf="selectedComponent === SettingsOption.DOCUMENT_TYPE">
				<app-document-type></app-document-type>
			</ng-container>

			<ng-container *ngIf="selectedComponent === SettingsOption.DOCUMENT_TEMPLATE">
				<app-document-template></app-document-template>
			</ng-container>
			<ng-container *ngIf="selectedComponent === SettingsOption.REGISTRE">
				<app-registre></app-registre>
			</ng-container>
			<ng-container *ngIf="selectedComponent === SettingsOption.OPERATORI">
				<app-operatori></app-operatori>
			</ng-container>
			<ng-container *ngIf="selectedComponent === SettingsOption.ZILE_LIBERE">
				<app-zile-libere></app-zile-libere>
			</ng-container>
			<!--
      <ng-container
        *ngIf="selectedComponent === SettingsOption.PLATFORM_SECTION"
      >
        <app-platform-section></app-platform-section>
      </ng-container>
      <ng-container *ngIf="selectedComponent === SettingsOption.PLATFORM_FAQ">
        <app-platform-faq></app-platform-faq>
      </ng-container>
      <ng-container
        *ngIf="selectedComponent === SettingsOption.PLATFORM_CONTENT"
      >
        <app-platform-content></app-platform-content>
      </ng-container>
      <ng-container
        *ngIf="selectedComponent === SettingsOption.PLATFORM_ANNOUNCES"
      >
        <app-platform-announces></app-platform-announces>
      </ng-container>
      -->
			<div class="row" *ngIf="selectedComponent == null">
				<div class="col-sm-12 py-5">
					<div class="row h-100 justify-content-center align-items-center">
						<div class="col-12 text-center">
							<div class="py-3">
								<p class="mb-0">Selectați o secțiune</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>